module.exports = __webpack_public_path__ + "img/7.cba4ec2f.png";